import React from "react";
//import '../App.css';
import Nav from "./nav";
import {withRouter} from 'react-router-dom';
import {Form,Container,Button,TabContainer,Row,Col,Alert} from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab'
import Demographics from "../pages/form/demographic";
import Clinical_data from "../pages/form/clinicaldata";
import Scans from "../pages/form/Scans";

import configuration from '../conf.json';

class  DataForm extends React.Component {
    userdata;

    constructor(props) {
        super(props);

        this.state = {
            userdata: {

            },
            clinicaldata: {

            },

            responseId: null,
            noEdit:true,
            Success:false,
            scans : new FormData(),
        }

        const data = new FormData()
        // this.handleChange = this.handleChange.bind(this);
        this.handleSubmit=  this.handleSubmit.bind(this);
    }

    handleChange = (event) => {
        const {name, value} = event.target

        this.setState(prevState => (
                {
                    userdata: {
                        ...prevState.userdata,
                        [name]: value
                    }


                }

            )
        );
    }
    handleChangeClinical = (event) => {
        const {name, value} = event.target

        this.setState(prevState => (
                {
                    clinicaldata: {
                        ...prevState.clinicaldata,
                        [name]: value
                    }

                }

            )
        );
    }


    handleSubmit =  (event) => {
        event.preventDefault()
        alert('Submission' + this.state)
      //  let data = {"userdata":this.state.userdata,"clinicaldata":this.state.clinicaldata}

        let data = {"userdata":this.state.userdata,"clinicaldata":this.state.clinicaldata}
        var header;
        if(this.props.patient == 'newVisit'){
            header = {'Content-Type': 'application/json',Patient_Id:this.props.id}
        }
        else {
            header = {'Content-Type': 'application/json'}
        }

        fetch(configuration["ADD-NEW-PATIENT"], {
            method: 'POST',
            headers: header,
            body: JSON.stringify(data)

        }).then((response)=> {
                if (response.status===200) {
                    this.setState(prevState => {
                        this.state.responseId = response.statusText
                    })
                    fetch("http://localhost:5000/patients/data/scans",{
                        method: 'POST',
                        headers: {'PatientID': this.state.responseId},
                        body: this.state.scans
                    }).then( (response)=> {
                        if(this.props.patient == 'newVisit') {
                            this.props.popup()
                        }
                    });
                }
            }

        )



        //data.append(this.state.scans)




    }
   handleFiles =(event,filename)=>{
        this.state.scans.set(filename,event.target.files[0])
   }


    componentDidMount() {
        if (this.props.patient == 'new'){
            this.setState(prevState =>({
                clinicaldata:{
                    ...prevState.clinicaldata,
                    visit:1
                }
            }))
        }
        else {
            this.setState(prevState=>({
                clinicaldata:{
                    ...prevState.clinicaldata,
                    visit:this.props.visit
                }
            }))
        }
   }

    render() {
          // === ADD NEW PATIENT ========

            return (
                <>

                    <Tabs defaultActiveKey="Patient-data" variant={'tabs'} id="uncontrolled-tab-example">
                        <Tab eventKey='Patient-data' title="Patient Data" tabClassName={'sdsd'}>
                            <div>
                            {this.props.patient ==='new'?<Demographics handler={this.handleChange} submit={this.handleSubmit}/>:<div></div>}



                            <Clinical_data handler={this.handleChangeClinical} action='new'/>
                            </div>

                        </Tab>
                        <Tab eventKey="Scans" title="Scan">
                            <div>
                            <Scans files={this.handleFiles}/>
                            </div>

                        </Tab>
                    </Tabs>
                    <Button className='submitbutton' variant='success' onClick={this.handleSubmit}>Submit</Button>

                </>
            );



    }
}

export default  DataForm;